import { Injectable } from '@angular/core';
import { ApiClientService } from 'projects/dnest-core-angular/src/public-api';
import { Speaker } from 'src/app/models/speaker';

@Injectable({
  providedIn: 'root'
})
export class SpeakerApiClientService extends ApiClientService<Speaker> {
  endpoint = 'speaker';
}

